import { FC } from 'react'
import { useTranslate } from 'react-admin'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import { VisualizationNodeData, WorkflowNodeData } from '../types'
import ExpressionTextField from '../autocomplete/ExpressionTextField'

interface VisualizationConfigProps {
  data: VisualizationNodeData
  onUpdate: (data: Partial<WorkflowNodeData>) => void
}

const VisualizationConfig: FC<VisualizationConfigProps> = ({ data, onUpdate }) => {
  const translate = useTranslate()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        label={translate('workflow.config.label')}
        value={data.label}
        onChange={(e) => onUpdate({ label: e.target.value })}
        size="small"
        fullWidth
      />

      <ExpressionTextField
        label={translate('workflow.config.sourceExpression')}
        value={data.sourceExpression ?? ''}
        onChange={(e) => onUpdate({ sourceExpression: e.target.value })}
        size="small"
        fullWidth
        placeholder="{{ nodes.get-casetype.output.data }}"
        helperText={translate('workflow.config.sourceExpressionHelp')}
      />
    </Box>
  )
}

export default VisualizationConfig
